module.exports = __webpack_public_path__ + "static/decima-nova-pro-regular-231e57150d254109145fe35368d3d98e.otf";